import React from 'react'
import { isClubLeaDomain, isStaging } from '../util'

function GeneralDisclaimer(props) {
    const companyId = props.companyId || null

    const openBilling = (ev) => {
        ev && ev.preventDefault()
        if (!companyId) {
            // open root MSL depending on environment
            const root = isClubLeaDomain()
                ? `https://auth.clublea.pro`
                : isStaging()
                ? `https://my-dev.synkd.life`
                : `https://my.synkd.life`
            window.open(root, '_blank', 'noopener,noreferrer')
            return
        }

        const url = isClubLeaDomain()
            ? `https://auth.clublea.pro/company/${companyId}/billing/info`
            : isStaging()
            ? `https://my-dev.synkd.life/company/${companyId}/billing/info`
            : `https://my.synkd.life/company/${companyId}/billing/info`
        window.open(url, '_blank', 'noopener,noreferrer')
    }

    return (
        <p className='disclaimer'> You can change Billing Email & Mobile in{' '}
            <a href="#" onClick={openBilling} rel="noopener noreferrer">MSL</a>.<br />
            Payments are handled by <a href="https://stripe.com/en-gb" target='_blank' rel='noopener noreferrer'>Stripe</a>.
        </p>
    )
}

export default GeneralDisclaimer